import { render, staticRenderFns } from "./zygd_more.vue?vue&type=template&id=09df3189&scoped=true&"
import script from "./zygd_more.vue?vue&type=script&lang=js&"
export * from "./zygd_more.vue?vue&type=script&lang=js&"
import style0 from "./zygd_more.vue?vue&type=style&index=0&id=09df3189&prod&lang=less&"
import style1 from "./zygd_more.vue?vue&type=style&index=1&id=09df3189&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df3189",
  null
  
)

export default component.exports